import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { HcProfessionalHdrContainerModel } from '../../../../../models/aggregates/healthcare/hc-professional-hdr-container.model';

@Injectable({providedIn: 'root'})
export class HcProfessionalHdrService extends BaseApiTemplateService<HcProfessionalHdrContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "professional-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  readonly endpointPathGeneric = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "professional-hdrs/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}